import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isAuthenticated: false,
    // apiURL: (window.VividArts && window.VividArts.apiURL) ? window.VividArts.apiURL : 'https://api.vividartsapp.com',

    apiURL: 'https://api.vividartsapp.com',
    errors: 0,
    axiosConfig: {
      headers: {
        'token': localStorage.getItem('token') ? localStorage.getItem('token') : null,
        'edomain': window.location.hostname.split('.')[0]
      }
    },
    user: { },
    enterprise: null,
    // userInitials: `${window.VividArts.uFName.substring(0, 1).toUpperCase()}${window.VividArts.uLName.substring(0, 1).toUpperCase()}`,
    // userFirstName: window.VividArts.uFName,
    // userLastName: window.VividArts.uLName,
    // userRole: window.VividArts.uRole,
    omittedCards: ['home', 'profile', 'addArtist'],
    emailVariables: [
      {
        value: false,
        name: 'First Name',
        var: '{{user_first_name}}',
        des: 'Users first name'
      },
      {
        value: false,
        name: 'Last Name',
        var: '{{user_last_name}}',
        des: 'Users first name'
      },
      {
        value: false,
        name: 'Login URL',
        var: '{{login_url}}',
        des: 'Users first name'
      },
      {
        value: false,
        name: 'Username',
        var: '{{username}}',
        des: 'Users first name'
      },
      {
        value: false,
        name: 'Generate Password',
        var: '{{temporary_password}}',
        des: 'Users first name'
      },
      {
        value: false,
        name: 'Reset Password Button',
        var: '{{reset_pwd_btn}}',
        des: 'Styled button to reset password'
      },
      {
        value: false,
        name: 'Vivid Arts Help Email',
        var: '{{vividarts_help_email}}',
        des: 'help@vividartsapp.com'
      },
      {
        value: false,
        name: 'Company Name',
        var: '{{company_name}}',
        des: 'Userame'
      },
      {
        value: false,
        name: 'Company Address',
        var: '{{company_address}}',
        des: 'Userame'
      },
      {
        value: false,
        name: 'Company Email',
        var: '{{company_email}}',
        des: 'Userame'
      }
    ],
    emailVariableHeaders: [
      {
        text: 'Name',
        align: 'left',
        value: 'name'
      },
      { text: 'Variable', value: 'var' },
      { text: 'Description', value: 'des' }
    ],

    placeholderArtistImg: 'http://res.cloudinary.com/vividarts/image/upload/c_scale,w_600/v1518396723/directory/ccpbc-artist-placeholder.jpg',
    config: {
      themeColor: '#9E9E9E'
    },

    states: [ 'AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN',
      'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY',
      'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'],
    countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
      'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands',
      'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica',
      'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
      'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana',
      'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India',
      'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia',
      'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania',
      'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia',
      'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
      'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
      'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan',
      'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor L\'Este', 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia',
      'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)',
      'Yemen', 'Zambia', 'Zimbabwe'
    ],
    statuses: ['active', 'pending', 'deleted'],
    types: ['Mural', 'Sculpture', 'Installation', 'Live Performance', 'Exhibition', 'Film Viewings', 'Art Walks', 'Social Event', 'Opening Reception', 'Artist Only', 'Historical Landmark', 'Eatery', 'Bar/Wine'],
    artworkTour: {
      artworks: [],
      directions: {}
    }
  },
  getters: {
    isAuthenticated () {
      return (this && this.$auth) ? this.$auth.isAuthenticated() : false
    },
    getToken () {
      return localStorage.getItem('token') ? localStorage.getItem('token') : null
    },
    getConfig () {
      return store.state.config
    },
    getEnterprise () {
      return store.state.enterprise
    },
    getUser () {
      let user = (store.state.user && store.state.user._id) ? store.state.user : JSON.parse(localStorage.getItem('user'))
      return user
    }
  },
  mutations: {
    loginUser (state, payload) {
      state.axiosConfig.headers.token = JSON.stringify(payload.token)
      store.state.user = payload.user
      localStorage.setItem('token', JSON.stringify(payload.token))
      localStorage.setItem('user', JSON.stringify(payload.user))
    },
    isAuthenticated (state, payload) {
      state.isAuthenticated = payload.isAuthenticated
    },
    setConfig (state, payload) {
      localStorage.setItem('themeOpts', JSON.stringify(payload.config))
      state.config = payload.config
    },
    setEnterprise (state, payload) {
      state.enterprise = payload.enterprise
    }
  },
  actions: {
    buildArtworkTour ({ commit, state }, data) {
      console.log('directions data', data)
      var url = 'http://vividartsapp.com/embeded/tours.php'

      var params = new URLSearchParams()
      params.append('u', data)

      axios.post(url, params)
      .then(response => {
        // JSON responses are automatically parsed.
        console.log('buildArtworkTour', response.data)

        if (response.data.status === 'OK') {
          commit('setArtworkTour', { directions: response.data })
        }
      })
      .catch(e => {
        console.log(e)
        // this.errors.push(e)
        // this.loadingRoute = true

        // this.loadingRoute = false
        // this.appStep = 1
      })
    },
    login (context, payload) {
      this.$auth.login(payload.user, payload.requestOptions).then((response) => {
        context.commit('isAuthenticated', {
          isAuthenticated: (this && this.$auth) ? this.$auth.isAuthenticated() : false
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js